import React from 'react';
import { Children, type ReactNode } from 'react';
import { cn } from '../../utils/ui';

export interface TooltipProps {
    className?: string;
    contentClassName?: string;
    children: ReactNode;
    content?: ReactNode | string;
    position?: 'left' | 'right' | 'center';
}

const Tooltip: FC<TooltipProps> = props => {
    const { children, content, contentClassName, className, position = 'center' } = props;

    function getBaseClassName() {
        return 'relative group cursor-pointer';
    }

    function getContentClassName() {
        const baseClasses =
            'transition text-gray-50 transition-discrete w-max absolute bottom-4 max-w-[300px] z-10 rounded-lg bg-gray-800 hidden group-mobile-hover:block group-focus:block px-2 py-1';

        const positionClasses = {
            center: 'right-1/2 translate-x-1/2',
            left: '-right-4',
            right: '-left-4',
        };

        return `${baseClasses} ${positionClasses[position]}`;
    }

    return (
        <div className={cn(getBaseClassName(), className)}>
            <div className={cn(getContentClassName(), contentClassName)}>{content}</div>
            {children}
        </div>
    );
};

export default Tooltip;
